import * as dt from './data.types.js';
const CONTAINER_SLOT_SCAN_TERMINAL_PHASES = new Set([
    dt.CONTAINER_SLOT_SCAN_JOB_PHASE.COMPLETED,
    dt.CONTAINER_SLOT_SCAN_JOB_PHASE.PARTIAL,
    dt.CONTAINER_SLOT_SCAN_JOB_PHASE.FAILED,
    dt.CONTAINER_SLOT_SCAN_JOB_PHASE.ABORTED,
]);
const BATCH_WAFER_TRANSFER_TERMINAL_PHASES = new Set([
    dt.BATCH_WAFER_TRANSFER_JOB_PHASE.COMPLETED,
    dt.BATCH_WAFER_TRANSFER_JOB_PHASE.PARTIAL,
    dt.BATCH_WAFER_TRANSFER_JOB_PHASE.FAILED,
    dt.BATCH_WAFER_TRANSFER_JOB_PHASE.ABORTED,
]);
export function isTerminalContainerSlotScanJobPhase(phase) {
    return CONTAINER_SLOT_SCAN_TERMINAL_PHASES.has(phase);
}
export function isTerminalBatchWaferTransferJobPhase(phase) {
    return BATCH_WAFER_TRANSFER_TERMINAL_PHASES.has(phase);
}
/** Terminal legacy batch-scan monitor statuses (mapped from container slot scan job phases). */
export const TERMINAL_BATCH_SCAN_STATUSES = [
    dt.BATCH_SCAN_STATUS.COMPLETED,
    dt.BATCH_SCAN_STATUS.PARTIAL,
    dt.BATCH_SCAN_STATUS.FAILED,
    dt.BATCH_SCAN_STATUS.ABORTED,
];
export function isTerminalBatchScanStatus(status) {
    return TERMINAL_BATCH_SCAN_STATUSES.includes(status);
}
//# sourceMappingURL=efem-job-phase.utils.js.map